export default {
    error_to_send_file: 'Error sending the file, please remove it and try again.',
    download_all_files: 'Download all files',
    sent_by: 'Sent by {{name}}',
}
